<template>
  <div class="section-2" id="clasificados">
    <div class="container">
      <div class="row">
        <div class="section-2__box-title py-3">
          <h2 class="section__title">Todos los atletas del Team Chile </h2>
          <img src="@/assets/image/logoolimpiadas.png" class="img-fluid">
        </div>
          <app-description-card />
      </div>
    </div>
  </div>
</template>
<script>
import AppDescriptionCard from '../commons/AppDescriptionCard.vue'
export default {
  data() {
    return {
      data: []
    }
  },
  components: { AppDescriptionCard },
}
</script>